import BaseTree, { TreeProps as BaseTreeProps } from 'antd/lib/tree/Tree'

export type { TreeNodeNormal } from 'antd/lib/tree/Tree'

export interface TreeProps extends BaseTreeProps {}

export function Tree(props: TreeProps): JSX.Element {
  return (
    <>
      <BaseTree {...props} />
    </>
  )
}

export default Tree
